import { HeartIcon as SolidHeartIcon } from "@heroicons/react/24/solid";
import { HeartIcon as OutlineHeartIcon } from "@heroicons/react/24/outline";

interface Props {
  isLike: boolean;
  onClick: () => void;
}

export default function LikeButton(props: Props) {
  const { isLike, onClick } = props;
  return (
    <button
      onClick={() => onClick()}
      className={`transition-transform ${isLike ? "heart-beat" : ""}`}
    >
      {isLike ? (
        <SolidHeartIcon className={"h-6 w-6 text-red-500"} />
      ) : (
        <OutlineHeartIcon className={"h-6 w-6 text-gray-600"} />
      )}
    </button>
  );
}
